module.exports = __webpack_public_path__ + "media/images/es_419/approach-segment-09b66db5a6a70b40793b9bc40382d222.jpg";